import { useEffect, useRef, useState } from "react"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { getWeeklyCount } from "../env"
const RefundCounter = () => {
	const [targetCount, setTargetCount] = useState(0)
	const [displayCount, setDisplayCount] = useState(0)
	const [isCountLoaded, setIsCountLoaded] = useState(false)
	const counterSectionRef = useRef<HTMLDivElement | null>(null)
	const hasAnimatedRef = useRef(false)

	async function checkOrders() {
		const rawCount = await getWeeklyCount()
		const parsedCount = Number(Array.isArray(rawCount) ? rawCount[0] : rawCount)
		setTargetCount(Number.isFinite(parsedCount) && parsedCount > 0 ? parsedCount : 0)
		setIsCountLoaded(true)
	}

	function animateCounter() {
		if (hasAnimatedRef.current) {
			return
		}
		hasAnimatedRef.current = true

		const currentValue = { value: 0 }
		gsap.to(currentValue, {
			value: targetCount,
			duration: 1.6,
			ease: "power2.out",
			onUpdate: () => {
				setDisplayCount(Math.round(currentValue.value))
			},
			onComplete: () => {
				setDisplayCount(targetCount)
			},
		})
	}

	useEffect(() => {
		checkOrders()
	}, [])

	useEffect(() => {
		gsap.registerPlugin(ScrollTrigger)
		if (!isCountLoaded || !counterSectionRef.current) {
			return
		}

		const trigger = ScrollTrigger.create({
			trigger: counterSectionRef.current,
			start: "top 82%",
			onEnter: animateCounter,
		})
		if (trigger.isActive) {
			animateCounter()
		}

		return () => {
			trigger.kill()
		}
	}, [targetCount, isCountLoaded])

	return (
		<div ref={counterSectionRef} className=" mx-auto text-center pt-0 md:pt-0 bg-blue/5 px-6">
			<div className="max-w-[1200px] mx-auto">
				<h3 className="text-blue mb-12 md:font-bold">Sichere Dir eine der noch verfügbaren Einlösungen dieser Woche<br/> (Aktionszeitraum: 01.09.–31.12.2026)</h3>
				<div className="mx-auto flex justify-center gap-2 self-center mb-12">
						<div className="grid grid-cols-3 items-center justify-items-center">
                            <p className="text-blue justify-self-end pr-6">Noch</p>
							  <div className="btn-yellow-count">{displayCount}</div>
                                <p className="text-blue justify-self-start pl-6">verfügbar</p>
						</div>
				</div>
                 <p className="text-[14px] md:text-[16px] text-center text-blue">Ist das Wochenkontingent aufgebraucht, stehen Dir jeden <br />
                        Dienstag ab 06:00 Uhr wieder neue Einlösungen zur Verfügung.</p>
			</div>
		</div >
	)
}

export default RefundCounter
